import funzione_collegamento from "../funzioni_server/pacchetti_lez_function"
import { getToken, getUserId } from "../auth";
import convertDate from "./converti_data.js"
import nome_id from "./nome_id"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useRef } from "react";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner } from "@fortawesome/free-solid-svg-icons";
import { DateTime } from 'luxon';
import differenzaOrario from "./differenza_ore.js"
import "./stili_funzione.css"
/* global $ */
export async function istruttori_disponibili({dataInizio=undefined,dataFine=undefined,id_lezione=undefined,utenti=undefined}) {
    const lezion_data= await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getLessonDates",
  })
  const periodiUten= await funzione_collegamento({
    userid: getUserId(),
    token: getToken(),
    logout_on_error: true,
    azione:"getUserWorkPeriods",
  })
    var lezioni_vere=[]
    for (let lezione of lezion_data) {
        if (lezione.lessondatestatus===1 | lezione.lessondatestatus===2) {lezioni_vere=[...lezioni_vere,lezione]}
    }
    if (typeof dataInizio === 'string') {
        dataInizio=convertDate(dataInizio)
        dataFine=convertDate(dataFine)
    }
    var istruttori=[]
    for (let utente of utenti) {
        if ((utente.type===1 | utente.type ===2 || utente.type===5) && utente.enabled===1 ) {
            for (let periodo of periodiUten){
                if (periodo.userid===utente.userid){
                    if ( (convertDate(periodo.workperioddatefrom)<=dataInizio && convertDate(periodo.workperioddateto)>=dataInizio  ) ){
                        istruttori=[...istruttori,utente.userid]
                    }
                }
            }
        }
    }
    var istruttori_disponibili=[]
    var istruttori_non_disp=[]
    for (let lezione of lezioni_vere) {
        const inizioLezione=convertDate(lezione.lessondatestart).toMillis()
        const fineLezione=convertDate(lezione.lessondateend).toMillis()

        if (((inizioLezione >= dataInizio && inizioLezione < dataFine) | (fineLezione >= dataInizio && fineLezione < dataFine) | (dataInizio >= inizioLezione && dataInizio < fineLezione) | (dataFine >= inizioLezione && dataFine < fineLezione)) && lezione.lessondateid !==id_lezione && dataInizio!==fineLezione && dataFine!==inizioLezione) {
            if (!istruttori_non_disp.includes(lezione.userid)) {
            istruttori_non_disp=[...istruttori_non_disp,lezione.userid]}
        }
        else if (lezione.lessondateid ===id_lezione && !istruttori.includes(lezione.userid)) {istruttori_disponibili=[...istruttori_disponibili,lezione.userid]
        }


    }
    for (let istruttore of istruttori) {if (!istruttori_non_disp.includes(istruttore)) {istruttori_disponibili=[...istruttori_disponibili,istruttore]}}
    var nomi_disponibili=[]
    for (let istruttore of istruttori_disponibili) {
    nomi_disponibili=[...nomi_disponibili,nome_id({id:istruttore,utenti:utenti})]
    }
    return nomi_disponibili
}
export function aggiungiTempo(data, tempoStr) {
  const [h, m] = tempoStr.split(":").map(Number);
  return data.plus({ hours: h, minutes: m });
}
export function convertiIdNoleggio(tipo_n) {
        if (typeof tipo_n === "number"){
        if (tipo_n===1)
            return "Attrezzatura completa"
        else if (tipo_n===2)
            return "Kite e barra"
        else if (tipo_n===3)
            return "Tavola twin tip"
        else if (tipo_n===4)
            return "Tavola surfino"
        else if (tipo_n===5)
            return "Tavola foil"
        else if (tipo_n===6)
            return "Harness"
        else if (tipo_n===7)
            return "Lycra e muta"
        else if (tipo_n===8)
            return "Caschetto e giubbotto"
        else if (tipo_n===9)
            return "Twin tip - Surfino"}
    else
        {if (tipo_n==="Attrezzatura completa")
            return 1
        else if (tipo_n==="Kite e barra")
            return 2
        else if (tipo_n === "Tavola twin tip")
            return 3
        else if (tipo_n === "Tavola surfino")
            return 4
        else if (tipo_n==="Tavola foil")
            return 5
        else if (tipo_n==="Harness")
            return 6
        else if (tipo_n==="Lycra e muta")
            return 7
        else if (tipo_n==="Caschetto e giubbotto")
            return 8
        else if (tipo_n==="Twin tip - Surfino")
            return 9}
}
export function convertiIdInventario(tipo_materiale){
    if (typeof tipo_materiale==="number"){
        if (tipo_materiale === 1)
            return  "Kite"
        else if (tipo_materiale === 2)
            return "Barra"
        else if (tipo_materiale === 3)
            return "Tavola twin tip"
        else if (tipo_materiale == 4)
            return "Surfino"
        else if (tipo_materiale == 5)
            return "Foil"
    }
    else {
        if (tipo_materiale === "Kite")
            return  1
        else if (tipo_materiale ==="Barra")
            return 2
        else if (tipo_materiale === "Tavola twin tip")
            return 3
        else if (tipo_materiale == "Surfino")
            return 4
        else if (tipo_materiale == "Foil")
            return 5
    }
}
export async function materialeDisponibile({dataInizio=undefined,dataFine=undefined,idEsclusi=[]}){
    const dataInizioDate=dataInizio
    const dataFineDate=dataFine
    dataFine=dataFine.toMillis()
    dataInizio=dataInizio.toMillis()
    const noleggi = await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getRentals",
    childs:["inventories"]
    })
    const inventario=await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getInventoryItems",
    })
    const lezioni= await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getLessonDates",
    filtri:{"lessondatesfrom":dataInizioDate.toFormat("yyyyMMdd"),"lessondatesto":dataInizioDate.plus({days:2}).toFormat("yyyyMMdd")},
    childs:["inventories"]
    })
    const escursioni=await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getExcursions",
    })
    const escursioni_mat= await funzione_collegamento({
    userid:getUserId(),
    token:getToken(),
    azione:"getLinkExcInvs",
    })
    var n_disponibili=[]
    for (let noleggio of noleggi){
        let inizioNolG=null
        let fineNolG=null
        if (noleggio.rentalfrom && noleggio.rentalto){
             inizioNolG=convertDate(noleggio.rentalfrom).toMillis()
             fineNolG=convertDate(noleggio.rentalto).toMillis()
        }
        if ((dataInizio<fineNolG &&dataInizio>=inizioNolG) | (dataFine<=fineNolG &&dataFine>inizioNolG) | (inizioNolG<dataFine && inizioNolG>=dataInizio) | (fineNolG<=dataFine && fineNolG>dataFine) | (!inizioNolG | !fineNolG)) {

            for (let i of noleggio.inventories){
                const inizioNol=convertDate(i.rentinvlinkfrom).toMillis()
                var fineNol=""
                if (i["rentinvlinkto"]!==undefined &&  i["rentinvlinkto"]!==""){
                    fineNol=convertDate(i.rentinvlinkto).toMillis()}
                else {
                    fineNol=convertDate(noleggio.rentalto).toMillis()}
                if (((inizioNol<=(dataInizio) && dataInizio<fineNol) | (inizioNol<=(dataFine) && dataFine<fineNol) | ((dataInizio<=inizioNol && inizioNol<(dataFine)) | ((dataInizio)<=fineNol && fineNol<(dataFine)))) && dataFine!==inizioNol && fineNol!=dataInizio && (!idEsclusi.includes(i.inventoryid)) ){

                    if (!n_disponibili.includes(i.inventoryid)){
                        n_disponibili=[...n_disponibili,i.inventoryid]
                    }
                }
            }
        }
    }

    for (let i of lezioni){
        const inizioLezione=convertDate(i.lessondatestart).toMillis()
        const fineLezione=convertDate(i.lessondateend).toMillis()

        if (((inizioLezione<=(dataInizio) && dataInizio<fineLezione) | (inizioLezione<=(dataFine) && dataFine<fineLezione) | ((dataInizio<=inizioLezione && inizioLezione<(dataFine)) | ((dataInizio)<=fineLezione && fineLezione<(dataFine)))) && dataFine!==inizioLezione && fineLezione!=dataInizio ){
            for (let j of i.inventories) {
                if (!n_disponibili.includes(j.inventoryid) && (!idEsclusi.includes(j.inventoryid))){
                    n_disponibili=[...n_disponibili,j.inventoryid]
                }
            }
        }
    }
    for (let i of escursioni){
        if (i["excursiontype"]===0 | i["excursiontype"]===1){
            const inizioEscursione=convertDate(i["excursiondatestart"]+"0900").toMillis()
            const fineEscursione=convertDate(i["excursiondatestart"]+"1900").toMillis()
            if (((dataInizio)<=(inizioEscursione) && inizioEscursione<(dataFine)) | ((dataInizio)<(fineEscursione) && fineEscursione<=(dataFine)) | ((inizioEscursione)<=(dataInizio) && dataInizio<(fineEscursione)) | ((inizioEscursione)<=(dataFine) && dataFine<(fineEscursione))) {
                for (let k of escursioni_mat){
                    if (k["excursionid"]==i["excursionid"] && (!idEsclusi.includes(k.inventoryid))){
                        if (!n_disponibili.includes(k.inventoryid)){
                            n_disponibili=[...n_disponibili,k.inventoryid]
                        }
                    }
                }
            }
        }
    }
    var inventario_disp=[]
    for (let i of inventario){
        if (!n_disponibili.includes(i.inventoryid)){
            if (!(i.inventorytype in inventario_disp)){inventario_disp[i.inventorytype]=[]}
            inventario_disp[i.inventorytype]=[...inventario_disp[i.inventorytype],{ID:i.inventoryid,nome:`${i.inventorybrand} ${i.inventorymeasure} ${i.inventorydescr} ${i.inventoryyear} ${i.inventorynotes ? i.inventorynotes : ""}`}]
        }
    }
    return inventario_disp
}
export function analisiMateriale(materiale,div,nome,tipoNoleggio,nomiAuth) {
    var noleggiTotali={}
    const oldSection = $(div).find("section.analisi-noleggi");
    for (let i of materiale){
        const giornataSlash=convertDate(i.rentinvlinkfrom,true)
        if (!noleggiTotali[giornataSlash]){
            noleggiTotali[giornataSlash]={}
        }
        if (i.rentalname){
            if (!(i.rentalname in noleggiTotali[giornataSlash])){
                noleggiTotali[giornataSlash][i.rentalname]=[]
            }
            noleggiTotali[giornataSlash][i.rentalname]=[...noleggiTotali[giornataSlash][i.rentalname],i]
        }
        else {
            if (!(nome in noleggiTotali[giornataSlash])){
                noleggiTotali[giornataSlash][nome]=[]
            }
            noleggiTotali[giornataSlash][nome]=[...noleggiTotali[giornataSlash][nome],i]
        }
    }
    let duratePersone={}
    for (let i in noleggiTotali) {
        let personeControlli={}
        for (let persona in noleggiTotali[i]){
            let ce_kite=false
            for (let noleggio of noleggiTotali[i][persona]){
                if (noleggio.inventorytype===1){
                    ce_kite=true
                }
            }
            for (let noleggio of noleggiTotali[i][persona]){
                if ((tipoNoleggio===1 && noleggio.inventorytype===1) || tipoNoleggio!==1 || !ce_kite){
                    const durataNol=(convertDate(noleggio.rentinvlinkto)-convertDate(noleggio.rentinvlinkfrom))/(60000*60)
                    if (noleggio.rentalname && !(noleggio.rentalname in personeControlli)){personeControlli[noleggio.rentalname]=0}
                    if (noleggio.rentalname)
                    {
                    personeControlli[noleggio.rentalname]+=durataNol}
                    else {
                        if (!(nome in personeControlli)){
                            personeControlli[nome]=0
                        }
                        personeControlli[nome]+=durataNol
                    }
                }
            }
        }
        duratePersone[i]=personeControlli
    }
    const container = document.createElement("section");
    container.className = "analisi-noleggi";

    const titolo = document.createElement("h2");
    titolo.textContent = `Analisi Noleggi di ${nome}`;
    container.appendChild(titolo);
    let costoGiornate = 0;
    let costoAssistenze = 0;
    let oreTotali = 0;
    for (const giorno in noleggiTotali) {
        const bloccoGiornata = document.createElement("div");
        bloccoGiornata.className = "giorno-noleggio";
        const h3 = document.createElement("h3");
        h3.textContent = `Noleggi del ${giorno}`
        bloccoGiornata.appendChild(h3);
        let costoGiornataTot=0
        let durataGiornataTot=0
        let costoAssistenzaG=0

        const bloccoGiorno= document.createElement("div");

        bloccoGiornata.appendChild(bloccoGiorno)
        for (const persona in noleggiTotali[giorno]){
            var riquadroObiettivo=bloccoGiorno
            var riquadroOb=bloccoGiorno
                if (Object.keys(noleggiTotali[giorno]).length>1){
                    const h3 = document.createElement("h3");
                    const riquadro1 = document.createElement("div");
                    riquadro1.classList.add("sottoblocco"); // puoi personalizzarlo via CSS
                    bloccoGiorno.appendChild(riquadro1);
                    h3.textContent = `Noleggi di ${persona}`;
                    riquadro1.appendChild(h3);
                    riquadroObiettivo=riquadro1
                    riquadroOb=riquadro1
                    bloccoGiorno.className = "giornata-noleggi";
                }
            if (noleggiTotali[giorno][persona].length>0){
                const ul = document.createElement("ul");
                let costoGiornata = 0;
                let durata=0
                let costoAssistenza=0
                durata=duratePersone[giorno][persona]
                var costoOra=0
                var costoGiorno=0
                let ce_kite=false
                for (let noleggio of noleggiTotali[giorno][persona]){
                    if (noleggio.inventorytype===1){
                        ce_kite=true
                    }
                }
                if (tipoNoleggio===1 && ce_kite){
                costoOra=50
                costoGiorno=70}
                else if (tipoNoleggio===2 ){
                costoOra=30
                costoGiorno=50}
                else {
                costoOra=30
                costoGiorno=40}
                durataGiornataTot+=durata
                if (durata<=1){
                costoGiornata=costoOra*durata
                costoGiornataTot+=costoOra*durata}
                else if (durata>1 && durata<=3){
                costoGiornata=(costoOra + ((durata) - 1) *10)
                costoGiornataTot+=(costoOra + ((durata) - 1) *10)}
                else {costoGiornata=costoGiorno
                costoGiornataTot=costoGiorno
                }
                for (const noleggio of noleggiTotali[giorno][persona]) {
                  const li = document.createElement("li");
                  const durataPezzo=(convertDate(noleggio.rentinvlinkto)-convertDate(noleggio.rentinvlinkfrom))/(60000*60)
                  const durataOra=differenzaOrario({dataInizio:convertDate(noleggio.rentinvlinkfrom),dataFine:convertDate(noleggio.rentinvlinkto)})
                  var costoPezzo=0
                  if ((tipoNoleggio===1 && noleggio.inventorytype===1) || tipoNoleggio!==1){
                  costoPezzo=(durataPezzo/durata)*costoGiornata }
                  var costoPezzoAssistenza=0
                  if (noleggio.assistedby!==0) {costoAssistenza+=durataPezzo*15
                  costoAssistenzaG+=durataPezzo*15
                  costoPezzoAssistenza=durataPezzo*15
                  }
                  li.textContent = `Noleggio ${durataOra} di ${convertiIdInventario(noleggio.inventorytype)} ${noleggio.inventorymeasure} ${noleggio.inventorydescr}. Costo noleggio: € ${costoPezzo.toFixed(2)}, costo assistenza: € ${costoPezzoAssistenza.toFixed(2)}. Totale: € ${(costoPezzo+costoAssistenza).toFixed(2)}`;
                  ul.appendChild(li);

                }
                costoGiornate+=costoGiornata
                costoAssistenze+=costoAssistenza
                oreTotali+=durata
                riquadroObiettivo.appendChild(ul);

               const riepilogo = document.createElement("p");
               if (Object.keys(noleggiTotali[giorno]).length>1){
               riepilogo.innerHTML = `<strong>Riepilogo giornata di ${persona}:</strong> Ore totali: ${differenzaOrario({dataInizio:(durata*3600000)})}. Costo noleggio: € ${costoGiornata.toFixed(2)}, costo assistenza: € ${costoAssistenza.toFixed(2)}. Totale: € ${(costoGiornata+costoAssistenza).toFixed(2)}`;
               }
               else {
               riepilogo.innerHTML = `<strong>Riepilogo giornata:</strong> Ore totali: ${differenzaOrario({dataInizio:(durata*3600000)})}. Costo noleggio: € ${costoGiornata.toFixed(2)}, costo assistenza: € ${costoAssistenza.toFixed(2)}. Totale: € ${(costoGiornata+costoAssistenza).toFixed(2)}`;
               }
               riquadroObiettivo.appendChild(riepilogo);
               container.appendChild(bloccoGiornata);
            }

        }
        if (Object.keys(noleggiTotali[giorno]).length>1){
            const tot=document.createElement("div")
            tot.classList.add("riepilogo")
            const riepilogo = document.createElement("p");
            riepilogo.innerHTML = `<strong>Riepilogo giornata:</strong> Ore totali: ${differenzaOrario({dataInizio:(durataGiornataTot*3600000)})}. Costo noleggio: € ${costoGiornataTot.toFixed(2)}, costo assistenza: € ${costoAssistenzaG.toFixed(2)}. Totale: € ${(costoGiornataTot+costoAssistenzaG).toFixed(2)}`;
            tot.appendChild(riepilogo);
            bloccoGiornata.appendChild(tot)
        }
    }

    // Riepilogo finale
    const riepilogoTotale = document.createElement("div");
    riepilogoTotale.className = "riepilogo-totale";

    const h3tot = document.createElement("h3");
    h3tot.textContent = "Riepilogo Totale";
    riepilogoTotale.appendChild(h3tot);

    const p1 = document.createElement("p");
    p1.innerHTML = `Totale noleggi: <strong>€ ${costoGiornate.toFixed(2)}</strong>, Totale assistenze: <strong>€ ${costoAssistenze.toFixed(2)}</strong>, Totale: <strong>€ ${(costoGiornate+costoAssistenze).toFixed(2)}</strong>`;
    const p2 = document.createElement("p");
    p2.innerHTML = `Giorni di noleggio: <strong>${Object.keys(noleggiTotali).length}</strong>`;
    const p3 = document.createElement("p");
    p3.innerHTML = `Ore totali: <strong>${oreTotali}</strong>`;

    riepilogoTotale.appendChild(p1);
    riepilogoTotale.appendChild(p2);
    riepilogoTotale.appendChild(p3);

    container.appendChild(riepilogoTotale);
    if (!oldSection.length) {
    div.appendChild(container);}
    else {
        oldSection.replaceWith(container);
    }
}

export function sovrapposti(inizio1,fine1,inizio2,fine2){
    if (typeof inizio1==="string"){
        inizio1=convertDate(inizio1).toMillis()
    }
    if (typeof fine1==="string"){
        fine1=convertDate(fine1).toMillis()
    }
    if (typeof inizio2==="string"){
        inizio2=convertDate(inizio2).toMillis()
    }
    if (typeof fine2==="string"){
        fine2=convertDate(fine2).toMillis()
    }
    if (((inizio1<=(inizio2) && inizio2<fine1) | (inizio1<=(fine2) && fine2<inizio2) | ((inizio2<=inizio1 && inizio1<(fine2)) | ((inizio2)<=fine1 && fine1<(fine2) && fine2!==inizio1 && fine1!=inizio2 )) )){
    return true}
    return false
}
export function ordinaPerData(array,stringa,dec) {
    if (!dec)
  return array.sort((a, b) =>
    convertDate(a[stringa]).toMillis() - convertDate(b[stringa]).toMillis()
  );
  else{
  return array.sort((a, b) =>
     convertDate(b[stringa]).toMillis()- convertDate(a[stringa]).toMillis()
  );
  }
}
export function convertiTipoStorage(tipo){
    if (typeof tipo==="number"){
        if (tipo===1) return "Storage"
        else if (tipo===2) return "Storage + 3 rescue"
        else if (tipo===3) return "Assistenza spiaggia"
    }
    else {
        if (tipo==="Storage") return 1
        else if (tipo==="Storage + 3 rescue") return 2
        else if (tipo==="Assistenza spiaggia") return 3
    }
}
export function prendiNomePacchetto(lezione,pacchetti){
    for (let pacchetto of pacchetti){
        if (pacchetto.lessonid==lezione.lessonid)
            return pacchetto.lessonstudentname
    }
}
export function coloreDaId(id) {
    const h = (parseInt(id, 10) * 137) % 360; // 137 per buona distribuzione
    return `hsl(${h}, 70%, 60%)`;
}
export async function pacchettiAperti(){
const datagen = await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        filtri:{"lessondatestatus":2},
        azione:'getLessons'
      });
      let data=[]
    for (let i of datagen) {
        if  (Math.abs(i.lessonhours-i.lessonpacket)>0.05 && i["lessonhours"]<i["lessonpacket"]+0.05) {
            data=[...data,i]
        }
    }
      return data
}
export function isoToString(isoString) {
  // Esempio input: "2025-05-22T14:30:00.000Z"
  // Prendi anno, mese, giorno, ora, minuti direttamente con substring
  const anno = isoString.substring(0, 4);
  const mese = isoString.substring(5, 7);
  const giorno = isoString.substring(8, 10);
  const ora = isoString.substring(11, 13);
  const minuti = isoString.substring(14, 16);

  return anno + mese + giorno + ora + minuti;
}
export function calcolaStipendioFisso(stipendiPersonale,utente,stipendiPagati,dataInizio,dataFine,periodi,cambio,escursioni,partecipanti,spese,stipendiPeriodi,periodiDettagliati){
    let datiIntervallo={}
    const dataInizioL=convertDate(dataInizio)
    const dataFineL=convertDate(dataFine)
    let current=dataInizioL
    const dataOra= DateTime.now()
    while (current <= dataFineL && current<=dataOra) {
        datiIntervallo[current.toFormat("yyyyMMdd")]=0
        current=current.plus({days:1})
    }
    for (let stipendio of stipendiPagati){
        let dataStip=convertDate(stipendio.salarydatefrom)
        if (stipendio.userid===utente.userid){
            for (let periodo of periodi){
                if (periodo.userid===utente.userid){
                    let inizioP=convertDate(periodo.workperioddatefrom)
                    let fineP=convertDate(periodo.workperioddateto)
                    if (dataStip>=inizioP && dataStip<fineP){
                        const stipendioDa=convertDate(stipendio.salarydatefrom)
                        const stipendioA=convertDate(stipendio.salarydateto)
                        let stipendioGiornaliero=stipendio.salaryvalue
                        if (stipendioA-stipendioDa!==0)
                        stipendioGiornaliero=stipendio.salaryvalue/((stipendioA-stipendioDa)/(3600*1000*24))
                        const inizio=convertDate(stipendio.salarydatefrom)
                        const fine=convertDate(stipendio.salarydateto)
                        let giorni=(fine-inizio)/(3600*24*1000)
                        if (giorni===0)giorni=1
                        for (let i=0 ; i<giorni ; i++){
                            if (inizio.plus({days:i}).toFormat("yyyyMMdd") in datiIntervallo)
                                {if (periodo.workperiodfixedsalarycurrency===1)
                                    datiIntervallo[inizio.plus({days:i}).toFormat("yyyyMMdd")]=stipendioGiornaliero
                                else{
                                    datiIntervallo[inizio.plus({days:i}).toFormat("yyyyMMdd")]=stipendioGiornaliero/cambio[inizio.plus({days:i}).toFormat("yyyyMMdd")]
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    for (let data in datiIntervallo){
        if (datiIntervallo[data]===0){
            let dataStip=convertDate(data)
            for (let periodo of periodi){
                if (periodo.userid===utente.userid){
                    let inizioP=convertDate(periodo.workperioddatefrom)
                    let fineP=convertDate(periodo.workperioddateto)
                    let pagaGiornaliera=0
                    if (dataStip>=inizioP && dataStip<fineP){
                        if (periodo.workperiodfixedsalaryfreq===0){
                            pagaGiornaliera=periodo.workperiodfixedsalary/30
                        }
                        else {
                            pagaGiornaliera=periodo.workperiodfixedsalary/7
                        }
                        if (periodo.workperiodfixedsalarycurrency===1)
                            datiIntervallo[data]=pagaGiornaliera
                        else{
                            datiIntervallo[data]=pagaGiornaliera/cambio[data]
                        }
                    }
                }
            }
        }
    }
    let totale=0
    for (let data in datiIntervallo){
        totale+=datiIntervallo[data]
        const dataLux=convertDate(data)
        const chiaveMese=dataLux.toFormat("yyyy-MM")
        const chiaveGiorno=dataLux.toISODate()
        const chiaveSettimana=`${dataLux.weekYear}-W${String(dataLux.weekNumber).padStart(2, "0")}`
        if (!(chiaveMese in stipendiPeriodi[1]))stipendiPeriodi[1][chiaveMese]=0
        stipendiPeriodi[1][chiaveMese]+=datiIntervallo[data]
        if (!(chiaveGiorno in stipendiPeriodi[3]))stipendiPeriodi[3][chiaveGiorno]=0
        stipendiPeriodi[3][chiaveGiorno]+=datiIntervallo[data]
        if (!(chiaveSettimana in stipendiPeriodi[2]))stipendiPeriodi[2][chiaveSettimana]=0
        stipendiPeriodi[2][chiaveSettimana]+=datiIntervallo[data]
        if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
       if (!("stipendi" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["stipendi"]={}
       if (!("fisso" in periodiDettagliati[1][chiaveMese]["stipendi"]))periodiDettagliati[1][chiaveMese]["stipendi"]["fisso"]={}
       if (!(utente.userid in periodiDettagliati[1][chiaveMese]["stipendi"]["fisso"]))periodiDettagliati[1][chiaveMese]["stipendi"]["fisso"][utente.userid]=0
        periodiDettagliati[1][chiaveMese]["stipendi"]["fisso"][utente.userid]+=datiIntervallo[data]
        if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
       if (!("stipendi" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["stipendi"]={}
       if (!("fisso" in periodiDettagliati[3][chiaveGiorno]["stipendi"]))periodiDettagliati[3][chiaveGiorno]["stipendi"]["fisso"]={}
        if (!(utente.userid in periodiDettagliati[3][chiaveGiorno]["stipendi"]["fisso"]))periodiDettagliati[3][chiaveGiorno]["stipendi"]["fisso"][utente.userid]=0
        periodiDettagliati[3][chiaveGiorno]["stipendi"]["fisso"][utente.userid]+=datiIntervallo[data]
        if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
        if (!("stipendi" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["stipendi"]={}
        if (!("fisso" in periodiDettagliati[2][chiaveSettimana]["stipendi"]))periodiDettagliati[2][chiaveSettimana]["stipendi"]["fisso"]={}
        if (!(utente.userid in periodiDettagliati[2][chiaveSettimana]["stipendi"]["fisso"]))periodiDettagliati[2][chiaveSettimana]["stipendi"]["fisso"][utente.userid]=0
        periodiDettagliati[2][chiaveSettimana]["stipendi"]["fisso"][utente.userid]+=datiIntervallo[data]

    }
    if (totale!==0){
        if (!(utente.userid in stipendiPersonale))stipendiPersonale[utente.userid]={}
        stipendiPersonale[utente.userid]["fisso"]=totale
    }
    for (let periodo of periodi){
        if (periodo.userid===utente.userid){
            let inizioP=convertDate(periodo.workperioddatefrom)
            let fineP=convertDate(periodo.workperioddateto)
            if (periodo.workperiodcommissionrate!==0){
                for (let escursione of escursioni){
                    const dataEscursione=convertDate(escursione.excursiondatestart.slice(0,8))
                    if (dataEscursione>=dataInizioL && dataEscursione<=dataFineL && dataEscursione>=inizioP && dataEscursione<fineP){
                        const dataLux=dataEscursione
                        const chiaveMese=dataLux.toFormat("yyyy-MM")
                        const chiaveGiorno=dataLux.toISODate()
                        const chiaveSettimana=`${dataLux.weekYear}-W${String(dataLux.weekNumber).padStart(2, "0")}`
                        const guadagnEs=guadagnoEscursione({cambio:cambio,escursione:escursione,partecipanti:partecipanti,spese:spese})
                        const guadagno=guadagnEs[0]-guadagnEs[1]
                        if (!(utente.userid in stipendiPersonale))stipendiPersonale[utente.userid]={}
                        if (!("commissioni" in stipendiPersonale[utente.userid]))stipendiPersonale[utente.userid]["commissioni"]=0
                        stipendiPersonale[utente.userid]["commissioni"]+=guadagno*(periodo.workperiodcommissionrate/100)
                         if (!(chiaveMese in periodiDettagliati[1]))periodiDettagliati[1][chiaveMese]={}
                       if (!("stipendi" in periodiDettagliati[1][chiaveMese]))periodiDettagliati[1][chiaveMese]["stipendi"]={}
                       if (!("escursioni" in periodiDettagliati[1][chiaveMese]["stipendi"]))periodiDettagliati[1][chiaveMese]["stipendi"]["escursioni"]={}
                       if (!(utente.userid in periodiDettagliati[1][chiaveMese]["stipendi"]["escursioni"]))periodiDettagliati[1][chiaveMese]["stipendi"]["escursioni"][utente.userid]=[]
                        periodiDettagliati[1][chiaveMese]["stipendi"]["escursioni"][utente.userid]=[...periodiDettagliati[1][chiaveMese]["stipendi"]["escursioni"][utente.userid],[escursione,periodo,guadagno]]
                        if (!(chiaveGiorno in periodiDettagliati[3]))periodiDettagliati[3][chiaveGiorno]={}
                       if (!("stipendi" in periodiDettagliati[3][chiaveGiorno]))periodiDettagliati[3][chiaveGiorno]["stipendi"]={}
                       if (!("escursioni" in periodiDettagliati[3][chiaveGiorno]["stipendi"]))periodiDettagliati[3][chiaveGiorno]["stipendi"]["escursioni"]={}
                        if (!(utente.userid in periodiDettagliati[3][chiaveGiorno]["stipendi"]["escursioni"]))periodiDettagliati[3][chiaveGiorno]["stipendi"]["escursioni"][utente.userid]=[]
                        periodiDettagliati[3][chiaveGiorno]["stipendi"]["escursioni"][utente.userid]=[...periodiDettagliati[3][chiaveGiorno]["stipendi"]["escursioni"][utente.userid],[escursione,periodo,guadagno]]
                        if (!(chiaveSettimana in periodiDettagliati[2]))periodiDettagliati[2][chiaveSettimana]={}
                        if (!("stipendi" in periodiDettagliati[2][chiaveSettimana]))periodiDettagliati[2][chiaveSettimana]["stipendi"]={}
                        if (!("escursioni" in periodiDettagliati[2][chiaveSettimana]["stipendi"]))periodiDettagliati[2][chiaveSettimana]["stipendi"]["escursioni"]={}
                        if (!(utente.userid in periodiDettagliati[2][chiaveSettimana]["stipendi"]["escursioni"]))periodiDettagliati[2][chiaveSettimana]["stipendi"]["escursioni"][utente.userid]=[]
                        periodiDettagliati[2][chiaveSettimana]["stipendi"]["escursioni"][utente.userid]=[...periodiDettagliati[2][chiaveSettimana]["stipendi"]["escursioni"][utente.userid],[escursione,periodo,guadagno]]
                    }
                }
            }
        }
    }


}
export function convertiIdRuolo(ruolo){
    if (typeof ruolo==="number"){
        if (ruolo==0)
            return "Owner"
        else if (ruolo==1)
            return "Owner-istruttore"
        else if (ruolo===2)
            return "Istruttore"
        else if (ruolo===3)
            return "Staff"
        else if (ruolo===4)
            return "Ospite"
        else if (ruolo===5)
            return "Istruttore su Commissioni"
    }
    else {
        if (ruolo=="Manager")
            return 0
        else if (ruolo=="Manager-istruttore")
            return 1
        else if (ruolo==="Istruttore")
            return 2
        else if (ruolo==="Staff")
            return 3
        else if (ruolo==="Ospite")
            return 4
        else if (ruolo==="Istruttore su Commissioni")
            return 5
    }
}
export function convertiColore(colore){
    let mappa={}
    if (typeof colore==="number"){
        mappa={1:"Rossa",2:"Gialla",3:"Blu",4:"Rosa",5:"Bianca",6:"Verde",7:"Nera",8:"Beige",9:"Azzurra N"}
    }
    else{
        mappa={"Rossa":1,"Gialla":2,"Blu":3,"Rosa":4,"Bianca":5,"Verde":6,"Nera":7,"Beige":8,"Azzurra N":9}
    }
    return mappa[colore]
}
export function convertiColoreLaccio(colore){
    let mappa={}
    if (typeof colore==="number"){
        mappa={1:"Rosso",2:"Verde",3:"Blu",4:"Arancione",5:"Nero"}
    }
    else{
        mappa={"Rossa":1,"Verde":2,"Blu":3,"Arancione":4,"Nero":5}
    }
    return mappa[colore]
}
export function convertiTaglia(colore){
    let mappa={}
    if (typeof colore==="number"){
        mappa={1:"S",2:"M",3:"L",4:"XL",5:"XS"}
    }
    else{
        mappa={"S":1,"L":2,"M":3,"XL":4,5:"XS"}
    }
    return mappa[colore]
}
export function convertiTipoAccessori(colore){
    let mappa={}
    if (typeof colore==="number"){
        mappa={1:"Maglietta",2:"Cappello",3:"Laccio per Occhiali"}
    }
    else{
        mappa={"Maglietta":1,"Cappello":2,"Laccio per Occhiali":3}
    }
    return mappa[colore]
}
export function convertiValuta(valuta){
if (typeof valuta==="number"){

        if (valuta==1)
            return "€"
        else if (valuta==2)
            return "-/"
    }
    else {
        if (valuta=="€")
            return 0
        else if (valuta=="-/")
            return 1
    }
}
export function convertiCambi(cambi,mercati){
    let cambiV={}
    for (let cambio of cambi){
        const valore=cambio.exchangerates.USDKES/cambio.exchangerates.USDEUR
        cambiV[cambio.exchangedatehour.slice(0,8)]=valore
    }
    return cambiV


}
export function guadagnoEscursione({cambio=undefined,partecipanti=undefined,escursione=undefined,spese=undefined, speseRit=true}){
    let incassoEsc=0
    let speseEsc=0
    let numeroPartec=0
    for (let persona of partecipanti){
        if (persona.excursionid===escursione.excursionid){
            numeroPartec+=1
            incassoEsc+=persona.excursioncustomerpaid
        }
    }
    for (let spesa of spese){
        if (spesa.excursionid===escursione.excursionid){
            let numeroSpesa=1
            if (spesa.excursioncostmultiple !== 0){
                numeroSpesa=numeroPartec
            }
            if (spesa.excursioncostcurrency===2){
                speseEsc+=(spesa.excursioncostvalue*numeroSpesa)/cambio[escursione.excursiondatestart.slice(0,8)]
            }
            else{
                speseEsc+=(spesa.excursioncostvalue*numeroSpesa)
            }
        }
    }
    if (speseRit)
    return [incassoEsc,speseEsc]
    else return incassoEsc-speseEsc
}
export function convertiIdEscursione(id){
const lista=["Downwind", "Kite Trip", "Dhow boat", "Dolphin watch - Safari marino", "Safari", "Marafa", "Sup rental", "Wakeboard","Jacaranda"]
    if (typeof id==="number")
        return lista[id]
    else
        return lista.indexOf(id)
}
export function calcolaRimanenza(id,periodo,stipendiPagati,lezioni,utente,pacchetti){
    let stipendioFissoOra=0
    const adesso=DateTime.now()
    let stipendi=ordinaPerData(stipendiPagati,"salarydatefrom")
    let ultimoStipendio=null
    if (stipendi[stipendi.length-1])
     ultimoStipendio=DateTime.fromFormat(stipendi[stipendi.length-1]["salarydateto"],"yyyyMMdd",{zone:"utc"})
    let saldato=true
    for (let lezione of lezioni){
        if (lezione.lessondatepaid===0){
            saldato=false
        }
    }
    let daSaldare=0
    let pagato=0
    let daPag=0
    if (!saldato || ultimoStipendio===null || ultimoStipendio.toMillis()!==DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"}).toMillis() ){
        if (saldato || ultimoStipendio===null || ultimoStipendio.toMillis()!==DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"}).toMillis()){; // ad esempio
            // Calcola quanti giorni mancano al prossimo giovedì (weekday = 4)
            let daysToAdd=null
            let start=null
            if (ultimoStipendio){
             daysToAdd = (11 - ultimoStipendio.weekday) % 7 || 7;
             start=ultimoStipendio}
            else{
            daysToAdd = (11 - DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}).weekday) % 7 || 7;
            start=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"})}
            const nextThursday = start.plus({ days: daysToAdd });
            const today = DateTime.utc().startOf('day');

            let count = 0;
            let current = start.startOf('day');
            const daysToAdd2 = (11 - current.weekday) % 7;
            current = current.plus({ days: daysToAdd2 });
            let current2=current
            while (current2 <= today && current2<=DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"}).toMillis() && current2>=DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}).toMillis()) {
              count += 1;
              if (periodo.workperiodfixedsalaryfreq===1)
              current2 = current2.plus({ days: 7 });
              else
              current2 = current2.plus({ months: 1 });
            }
            if (current2 > today && count===1){
                current2=current
            }
            if (current2 <= today){
                if (count===0){
                    for (let stipendio in stipendiPagati){
                        pagato+=stipendio.salaryvalue
                    }

                    if (periodo.workperiodfixedsalaryfreq===1)
                    daPag=((DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"}).toMillis() - DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}).toMillis())/(24*3600000*7))*periodo.workperiodfixedsalary
                    else
                    daPag=((DateTime.fromFormat(periodo["workperioddateto"],"yyyyMMdd",{zone:"utc"}).toMillis() - DateTime.fromFormat(periodo["workperioddatefrom"],"yyyyMMdd",{zone:"utc"}).toMillis())/(24*3600000*30))*periodo.workperiodfixedsalary
                    daSaldare=daPag-pagato
                }
                else{
                    for (let stipendio in stipendiPagati){
                            pagato+=stipendio.salaryvalue
                        }
                    daPag=count*periodo.workperiodfixedsalary
                    daSaldare=daPag-pagato
                }
            }

        }
    }
    for (let lezione of lezioni){
        if (lezione.lessondatepaid===0){
            let paga=0
            for (let pacchetto of pacchetti){
                if (pacchetto.lessonid===lezione.lessonid){
                    if (pacchetto.lessonnumstudents===1) paga=periodo.workperiodhourlypayment
                    else paga=periodo.workperiodhourlypaymentgroups
                }
            }
            daSaldare+=((convertDate(lezione.lessondateend)-convertDate(lezione.lessondatestart))/(3600*1000))*paga
        }
    }
}
export function criptaRuolo(ruolo, chiave) {
  const ruoloStr = ruolo.toString();
  let risultato = "";

  for (let i = 0; i < ruoloStr.length; i++) {
    const rChar = ruoloStr.charCodeAt(i);
    const kChar = chiave.charCodeAt(i % chiave.length);
    risultato += String.fromCharCode(rChar ^ kChar);
  }

  return btoa(risultato); // Codifica in Base64
}
export function decriptaRuolo(cifrato, chiave) {
  const testo = atob(cifrato); // Decodifica da Base64
  let risultato = "";

  for (let i = 0; i < testo.length; i++) {
    const cChar = testo.charCodeAt(i);
    const kChar = chiave.charCodeAt(i % chiave.length);
    risultato += String.fromCharCode(cChar ^ kChar);
  }

  return parseInt(risultato); // Converte di nuovo in numero
}
export async function camereDisponibili(inizio,fine,esclusa){
    const prenotazioni=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getBookings'
      });
    const camereLink=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getLinkBookingRooms'
      });
    const camere=await funzione_collegamento({
        userid: getUserId(),
        token: getToken(),
        logout_on_error: true,
        azione:'getBookingRooms'
      });
    let camereDis=camere.filter(item=>item.roomusable===1)
    for (let i of prenotazioni){
        let inizio2=null
        if (i.bookingcheckindate.length===8)
        inizio2=DateTime.fromFormat(i.bookingcheckindate,"yyyyMMdd",{zone:"utc"}).toMillis()
        else
        inizio2=DateTime.fromFormat(i.bookingcheckindate,"yyyyMMddHHmm",{zone:"utc"}).toMillis()
        let fine2=null
        if (i.bookingcheckoutdate.length===8)
        fine2=DateTime.fromFormat(i.bookingcheckoutdate,"yyyyMMdd",{zone:"utc"}).toMillis()
        else fine2=DateTime.fromFormat(i.bookingcheckoutdate,"yyyyMMddHHmm",{zone:"utc"}).toMillis()
        if (sovrapposti(inizio,fine,inizio2,fine2) ){
            for (let camera of camereLink){
                if (camera.bookingid===i.bookingid && camera.roomid!==esclusa){

                    camereDis= camereDis.filter(item => item.roomid !== camera.roomid);
                }
            }
        }
    }
    return camereDis
}
export function decodificaExtra(extra){
let mappa={}
    if (typeof extra==="string"){
        mappa={"Transfer":1}
    }
    else {mappa={1:"Transfer"}}
    return mappa[extra]
}
export function decodificaNazionalita(nazionalita){
    let mappa={}
    if (typeof nazionalita==="string"){
        mappa={"Non definito":0,"Italia":1,"Francia":2,"Germania":3,"Spagna":4,"Olanda":5,"Svizzera":6,"Nairobi":7,"Austria":8,"Paesi Bassi":9,"Gran Bretagna":10}
    }
    else {mappa={0:"Non definito",1:"Italia",2:"Francia",3:"Germania",4:"Spagna",5:"Olanda",6:"Svizzera",7:"Nairobi",8:"Austria",9:"Paesi Bassi",10:"Gran Bretagna"}}
    return mappa[nazionalita]
}
export function getLinguaMessaggio(lingua){
    if ([1,2,3,4].includes(lingua)){
     if (lingua===1) return "Italiano"
     else if (lingua===2) return "Francese"
     else if (lingua===3) return "Tedesco"
     else if (lingua===4) return "Spagnolo"
     }
    else return "Inglese"
}
export function getIDLingua(lingua){
    if (["Italiano","Francese","Tedesco","Spagnolo"].includes(lingua)){
     if (lingua==="Italiano") return 1
     else if (lingua==="Francese") return 2
     else if (lingua==="Tedesco") return 3
     else if (lingua==="Spagnolo") return 4
     }
    else return 0
}
export function convertiTipoRiparazione(tipo){
    let mappa={}
    if (typeof tipo==="number"){
        mappa={1:"Strappo trealing edge",2:"Strappo canopy",3:"Kite aperto",4:"Strappo leading edge",5:"Riparazioni buchi bladder",6:"Valvola scollata",7:"Tubi one pump"}
    }
    else{
        mappa={"Strappo trealing edge":1,"Strappo canopy":2,"Kite aperto":3,"Strappo leading edge":4,"Riparazioni buchi bladder":5,"Valvola scollata":6,"Tubi one pump":7}
    }
    return mappa[tipo]
}
